const TIME_ONLY_PATTERN = /^(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,7}))?)?$/;
/**
 * Parses serializer time-only values and returns canonical HH:mm.
 * Ordinary values are within 00:00-23:59. End-boundary values additionally
 * permit exactly 24:00, including the .NET TimeSpan form 1.00:00:00.
 */
export function parseTimeOnly(value, semantics = "ordinary") {
    if (semantics === "end-boundary" && value === "1.00:00:00") {
        return "24:00";
    }
    const match = TIME_ONLY_PATTERN.exec(value);
    if (!match)
        return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    const seconds = match[3] === undefined ? 0 : Number(match[3]);
    if (minutes > 59 || seconds > 59)
        return null;
    if (hours === 24) {
        return semantics === "end-boundary" && minutes === 0 && seconds === 0
            ? "24:00"
            : null;
    }
    if (hours > 23)
        return null;
    return `${match[1]}:${match[2]}`;
}
export const normalizeOrdinaryTimeOnly = (value) => parseTimeOnly(value, "ordinary");
export const normalizeEndBoundaryTimeOnly = (value) => parseTimeOnly(value, "end-boundary");
export function requireOrdinaryTimeOnly(value, fieldName = "time") {
    const normalized = normalizeOrdinaryTimeOnly(value);
    if (normalized === null)
        throw new Error(`Invalid ${fieldName}`);
    return normalized;
}
export function requireEndBoundaryTimeOnly(value, fieldName = "time") {
    const normalized = normalizeEndBoundaryTimeOnly(value);
    if (normalized === null)
        throw new Error(`Invalid ${fieldName}`);
    return normalized;
}
